export default __webpack_public_path__ + "static/david-65e43d77dbf300ba8fd601a8cd4d82a0.jpg";